export default {
  wellDoneExclamation: 'Well done!',
  wellDone: 'Well done',
  youGotXStars: 'You got {stars} star{{s}}.',
  backToHome: 'Back to home',
  totalPoints: 'Total:',
  practiceResults: 'Practice results',
  readyToGoForGold: 'Ready to go for gold?',
  results: 'Results',
  youCompletedQuiz: 'You have completed the quiz.',
  youCompletedPracticeQuiz: 'You have completed the practice quiz.',
  youGotAllStars: 'You got all the stars.',
  withPracticeParentheses: '{0} (Practice Mode)',

  modals: {
    allAnswerBoxesNeedToBeFilled: 'All the answer boxes need to be filled.',
    allPartsOfThePieChartMustBeFilled: 'All parts of the pie chart must be filled.',
    atLeastOneAnswerNeedsToBeSelected: 'At least one answer needs to be selected.',
    anAnswerNeedsToBeSelected: 'An answer needs to be selected.',
    checkAllAnswerBoxesFilled: 'Check you have answered all of the boxes and try again.',
    checkYouHaveSelectedAnAnswer: 'Check you have selected an answer.',
    checkYouHaveSelectedAllRequiredAnswers: 'Check you have selected all required answers.',
    checkYouHaveTheCorrectAnswerAndTryAgain: 'Check you have the correct answer and try again.',
    confirmExitQuiz: 'Are you sure you want to exit?',
    dragAtLeastPartOfACircleIntoThePictogram: 'Drag at least part of a circle into the pictogram.',
    endQuiz: 'End the quiz?',
    noAnswer: 'Oops, no answer',
    pleaseEnterAnswer: 'Please enter your answer for this question.',
    practice: 'Practice',
    practiceModeEarnSilverStars: 'Practice mode: Earn silver stars without affecting your score.',
    practiceOrRetry: 'Practice or Retry',
    retryQuestionX: 'Retry question {0}',
    retryQuiz: 'Retry quiz',
    selectAnAnswerBox: 'Select an answer box.',
    skipTryNext: 'Try the next question',
    skipSeeResults: "Let's see how you did",
    skipPreview: 'Resetting question',
    tryAgain: 'Try again',
    tryForGoldStars: 'Try for gold stars',
    thenTypeYourAnswer: 'Then type your answer.',
    xAttemptsRemaining: '{attemptsRemaining} attempt{{s}} at this question remaining.',
    youMustDragAllTheCirclesOntoTheDiagram: 'You must drag all the circles onto the diagram.',
    youMustDragAtLeastOneBar: 'You must drag at least one bar',
    youMustDragAtLeastOneBase10IntoTheAnswerBox:
      'You must drag at least one base 10 into the answer box.',
    youMustDragAtLeastOneCoinOrNoteIntoTheAnswerBox:
      'You must drag at least one coin or note into the answer box.',
    youMustDragAtLeastOneCounterIntoThePlaceValueChart:
      'You must drag at least one counter into the place value chart.',
    youMustDragTheArrowToAnswerTheQuestion: 'You must drag the arrow to answer the question.',
    youMustDragTheLinesToMakeAnAngle: 'You must drag the lines to make an angle.',
    youMustDragAtLeastOneCardIntoTheTallyChart:
      'You must drag at least one card into the tally chart.',
    youMustDragAtLeastOneCounterIntoTheTenFrame:
      'You must drag at least one counter into the ten frame.',
    youMustTapAtLeastOneCounter: 'You must tap at least one counter.',
    youMustTapAtLeastOnePartOfEachGrid: 'You must tap at least one part of each grid.',
    youMustTapAtLeastOnePartOfTheBarModel: 'You must tap at least one part of the bar model.',
    youMustTapAtLeastOnePartOfTheChart: 'You must tap at least one part of the chart.',
    youMustTapAtLeastOnePartOfTheDiagram: 'You must tap at least one part of the diagram.',
    youMustTapAtLeastOnePartOfTheGrid: 'You must tap at least one part of the grid.',
    youMustTapAtLeastOnePartOfTheShape: 'You must tap at least one part of the shape.',
    youMustTapAtLeastOneCircle: 'You must tap at least one circle.',
    youMustTapAtLeastOneShape: 'You must tap at least one shape.',
    youMustTapAtLeastOneSquare: 'You must tap at least one square.',
    youMustTapOnADot: 'You must tap on a dot.',
    youMustTapTheDiagramToAnswerTheQuestion: 'You must tap the diagram to answer the question.',
    youHaveNotTappedYourAnswer: 'You have not tapped your answer.'
  },

  errors: {
    errorBoundaryTitle: 'Oh no, something went wrong!',
    errorBoundaryBody: "We'll fix it as soon as possible."
  }
};
